import { useState } from 'react'
import { Tooltip } from 'antd'
import GeneralButton from '../../components/button/GeneralButton'
import FormInput from '../../components/formInput/FormInput'
import AddNewCategory from '../../components/modals/AddNewCategory'
import UploadCategoriesExcelModal from '../../components/modals/UploadCategoriesExcelModal'
import MergingCategories from '../../components/modals/MergingCategories'
import CategoriesTable from '../../components/table/CategoriesTable'
import useCategoryHook from './customHooks/useCategoryHook'

import { FiGrid, FiSearch } from "react-icons/fi"
const Categories = () => {
    const { allCategories, handleDelete, submitCategory, setSelectedCategory, modalOpen, toggleModal, selectedCategory, searchValue,
        setSearchValue,
        setCanSearch, } = useCategoryHook()

    const [mergeModalOpen, setMergeModalOpen] = useState(false);
    const toggleMergeModal = () => setMergeModalOpen(!mergeModalOpen);

    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const toggleUploadModal = () => setUploadModalOpen(!uploadModalOpen);

    return (
        <div className="settings-container">
            <AddNewCategory
                isOpen={modalOpen}
                toggle={toggleModal}
                onSubmit={submitCategory}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
            />

            <MergingCategories
                modal={mergeModalOpen}
                toggle={toggleMergeModal}
            />

            <UploadCategoriesExcelModal
                isOpen={uploadModalOpen}
                toggle={toggleUploadModal}
                allCategories={allCategories}
            />

            <div className="px-4">
                <div className="d-flex justify-content-between align-items-center mb-4 search-input-wrapper">
                    <div className="d-flex align-items-center gap-3 flex-1">
                        <div className="bg-primary-soft p-3 rounded-circle shadow-sm">
                            <FiGrid size={24} className="text-primary" />
                        </div>
                        <div>
                            <h4 className="fw-bold text-dark mb-0">Categories</h4>
                            <p className="text-muted small mb-0 mt-1">Management</p>
                        </div>
                    </div>

                    <div className="flex-1 d-flex justify-content-center">
                        <div style={{ width: "400px" }}>
                            <FormInput
                                type="text"
                                placeholder="Find a category..."
                                size="large"
                                className="border-0 shadow-none"
                                icon={<FiSearch size={20} className="text-muted" />}
                                value={searchValue}
                                handleChange={(e) => {
                                    setCanSearch(true)
                                    setSearchValue(e.target.value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="d-flex gap-3 flex-1 justify-content-end">
                        <Tooltip title="Update categories in bulk using an Excel file">
                            <span>
                                <GeneralButton
                                    title={"Upload Excel"}
                                    className={"btn-action bg-white text-success border shadow-sm px-3"}
                                    handleClick={toggleUploadModal}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="Merge multiple categories into a single category">
                            <span>
                                <GeneralButton
                                    title={"Merge Categories"}
                                    className={"btn-action bg-white text-dark border shadow-sm px-3"}
                                    handleClick={toggleMergeModal}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="Create a new category manually">
                            <span>
                                <GeneralButton
                                    title={"Add New Category"}
                                    className={"create-user-btn text-white shadow-sm px-4"}
                                    handleClick={() => {
                                        setSelectedCategory(null);
                                        toggleModal()
                                    }}
                                />
                            </span>
                        </Tooltip>
                    </div>
                </div>

                <div className="settings-card">
                    <CategoriesTable
                        setSelectedCategory={setSelectedCategory}
                        modal={modalOpen}
                        data={allCategories}
                        toggle={toggleModal}
                        handleDelete={handleDelete}
                        onClearSearch={searchValue ? () => {
                            setSearchValue("");
                            setCanSearch(true);
                        } : undefined}
                    />
                </div>
            </div>
        </div>
    )
}

export default Categories


